// Routing utility to create page URLs
export function createPageUrl(pageName: string): string {
  const routes: Record<string, string> = {
    Home: '/',
    Events: '/events',
    CreateEvent: '/events/create',
    EditEvent: '/events/edit',
    EventPortal: '/portal',
    Login: '/login',
    SignUp: '/signup',
    AdminUsers: '/admin/users',
    SetPassword: '/set-password',
    Settings: '/settings',
    Resources: '/resources',
  };

  return routes[pageName] || '/';
}
